import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";

import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import TopBusinessQuotesWrapper from "@components/layouts/topBusinessQuotesWrapper";

export default function TopBusinessQuotesHome(): ReactElement {
    return (
        <TopBusinessQuotesWrapper>
            <TermsAndConditions domain="TopBusinessQuotes.com" category="B2B" />
        </TopBusinessQuotesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
